import { data } from 'jquery'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { addComfort, getSingleComfort, updateComfert } from '../../../actions/homeAction'

const ComfortAdd = () => {
  const [comfort, setComfort] = useState({
    comfort:'',
    comfortAr:'',
    priority: null,
    active: true
  })
  const [dataEdit, setDataEdit] = useState(false)

const {cfUUID} = useParams()

const dispatch = useDispatch()

const location = window.location.href.split('/')[6]

useEffect(() => {
  if(location === 'Update'){
    dispatch(getSingleComfort(cfUUID))
    setDataEdit(true)
  } else {
    setDataEdit(false)
  }
},[])

const singleComfort = useSelector(state => state.home.singleComfirt)?.response
const data = singleComfort

useEffect(() => {
  setComfort({
    comfort: data?.comfort,
    comfortAr: data?.comfortAr,
    priority: data?.priority,
    active: data?.active === 0 ? 'false' : 'true'
  })
},[data?.comfort])

  const onChangeHandle = (e) => {
    const {name, value} = e.target
    setComfort({...comfort, [name]:value})
  }
  
  const onSave = () => {
    if(dataEdit){
      const payload = {
        comfort:comfort.comfort,
        comfortAr:comfort.comfortAr,
        priority: comfort.priority,
        active: comfort.active,
        comfortId: data.comfortId
        }
        dispatch(updateComfert(payload))
      } else {
        dispatch(addComfort(comfort))
    }
  }
console.log("datadata", comfort);

  return (
    <div className='main-body'>
    <div className='page-wrapper'>
      <div className='page-header'>
        <div className='row align-items-end'>
          <div className='col-lg-8'>
            <div className='page-header-title'>
              <div className='d-inline'>
                <h4>
                  { dataEdit ? `Edit : ${data?.comfort}` : "Add Comfort" } 
                </h4>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='page-header-breadcrumb'>
              <ul className='breadcrumb-title'>
                <li className='breadcrumb-item'>
                  <Link to='/'>
                    <i className='feather icon-home'></i>{' '}
                  </Link>
                </li>
                <li className='breadcrumb-item'>
                  <Link to='/CarDetail/Comfort'>Comfort</Link>
                </li>
                <li className='breadcrumb-item active'>
                { dataEdit ? "Edit Comfort" : "Add Comfort" } 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='page-body'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='card card-border-default'>
              <div className='card-block'>
                
                <div className='tab-content tabs'>
                  <div
                    className='tab-pane  active'
                    id={'car_user_'}
                    role='tabpanel'
                    aria-labelledby=''>
                      <div className=''>
        	<div className='col-md-6'>
							
						</div>

        {/* sdjkfj */}
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Comfort Name</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='comfort'
										value={comfort.comfort}
										placeholder='Comfort Name'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Comfort Name Ar</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='comfortAr'
										value={comfort.comfortAr}
										placeholder='Comfort Name Ar' 
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>

              <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Priority</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    name='priority'
                                    value={comfort.priority}
                                    placeholder='Priority'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
						
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='active'
										className='form-control'
										onChange={onChangeHandle}
										value={comfort?.status}
                    >
										<option value='true' name='active'>
											Active
										</option>
										<option value='false' name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						<div className='row float-right p-3'>
							
							<button
								onClick={onSave}
								className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> { dataEdit ? "Edit" : "Save" }
							</button>
							<Link to={'/CarDetail/Comfort'} className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ComfortAdd